<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Shedule Maintenance </h6>
 
  <h6 class="custom-maintitle "><b>Shedule Maintenance</b></h6>






 

  <div class="card" >
    <div class="card-body" >
      <full-calendar style="margin-right:0px;margin-left:0px; " :events="fcEvents" locale="en"></full-calendar>

    </div>
</div>
    

      

  
    
    

  


</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import Vue from "vue";
import fullCalendar from 'vue-fullcalendar'

Vue.component('full-calendar', fullCalendar)

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        fcEvents: [
  {
    title: 'Perfect Day for Rain',
    start: '2016-05-15',
    end: '2016-05-20',
    
  },
  {
    title: 'Wait another month for VueConf',
    start: '2017-05-21',
    end: '2017-05-22',
    cssClass: 'vueconf'
  },
  {
    title: 'A single sunny day',
    start: '2017-05-29',
    end: '2017-05-29'
  }
]
       
       
        
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     



    },
methods : {

 
  
 
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar,
     
    },
  }

</script>
<style >

.comp-full-calendar {
  padding: 20px; 
    background: #fff;
    max-width: 100% !important;
    margin: 0 auto;
}

</style>